import styled from '@emotion/styled';
import Image from 'next/image';

const StyledImage = styled(Image)`
  border-radius: 0.75rem;
  max-width: 100%;
  height: auto;
`;

export { StyledImage };
